'use client';

import SmoothScroll from './smooth-scroll';

export default function ScrollControl() {
  return (
    <SmoothScroll
      options={{
        duration: 1.2, // Smooth scroll duration (affects acceleration/deceleration)
        smoothWheel: true, // Enable smooth wheel scrolling with momentum
        smoothTouch: false, // Keep native touch scrolling for better mobile performance
        wheelMultiplier: 1, // Adjust scroll speed
        touchMultiplier: 2, // Touch scroll multiplier
      }}
    />
  );
}

